import { folderTypes } from "routes/schedule/folder-manager/add-folder"
import { scopeOf } from "routes/regime/plugins/regime-search/lib/search-scopes.js"

const DEFAULT_ICON = "material-symbols:folder-rounded"

const BREADCRUMB_ICONS = {
    regime: "pajamas:issue-type-maintenance",
    facility: "mdi:office-building",
    floor: folderTypes.floor.icon,
    space: "fluent:conference-room-24-filled",
}

const SCOPE_ICONS = {
    asset: "mdi:cube-outline",
    regime: "solar:buildings-line-duotone",
    facility: BREADCRUMB_ICONS.facility,
    floor: BREADCRUMB_ICONS.floor,
    space: BREADCRUMB_ICONS.space,
    schedule: "mdi:file-document-outline",
}

// The "All" scope isn't a real result type, so it gets its own icon rather than a SCOPE_ICONS entry.
const ALL_SCOPE_ICON = "mdi:apps"

export function iconForBreadcrumbType(type) {
    return BREADCRUMB_ICONS[type] ?? DEFAULT_ICON
}

export function iconForScope(scope) {
    if (scope === "all") return ALL_SCOPE_ICON
    return SCOPE_ICONS[scope] ?? DEFAULT_ICON
}

export function iconForResult(item) {
    const scope = scopeOf(item)
    if (scope === "asset" || scope === "regime") return SCOPE_ICONS[scope]
    return item.data?.icon ?? SCOPE_ICONS[scope] ?? folderTypes[item.data?.subType]?.icon ?? DEFAULT_ICON
}
